// 国家代码选项

export const countryCodeOptions = [
    { label: '+1', value: 1 },
    { label: '+86', value: 86}
];